import React, { useState } from "react";
import "./Leadership.css";
import Loader from "../Loader/Loader";

const Leadership = ({ title, directors }) => {
  const [selectedDirector, setSelectedDirector] = useState(null);

  const handleCardClick = (member) => {
    setSelectedDirector(member);
  };

  const handleClosePopup = () => {
    setSelectedDirector(null);
  };

  if (!directors || directors.length === 0) return <Loader />;

  return (
    <section className="leadership-section key-members-container">
      {title && <h2 className="key-members-title">{title}</h2>}
      <hr className="key-members-SectionLine" />

<div className="key-members-grid">
  {directors.map((member, index) => (
    <div
      key={index}
      className="key-member-card"
      onClick={() => handleCardClick(member)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && handleCardClick(member)}
    >
      <div className="key-member-photo">
        <img
          src={`/${member.image}`}
          alt={member.name}
          className="member-photo"
        />
      </div>
      <div className="key-member-details">
        <h3 className="key-member-name">{member.name}</h3>
        <p className="key-member-position">{member.position}</p>
      </div>
    </div>
  ))}
</div>


      {selectedDirector && (
        <aside className="menu-bar active" role="dialog" aria-modal="true">
          <button
            className="close-button"
            onClick={handleClosePopup}
            aria-label="Close"
          >
            ×
          </button>
          <img
            src={`/${selectedDirector.image}`}
            alt={selectedDirector.name}
            className="menu-photo"
          />
          <div className="menu-content">
            <h3 className="director-name">{selectedDirector.name}</h3>
            <p className="director-position">
              <strong>{selectedDirector.position}</strong>
            </p>
            {selectedDirector.description && (
              <p className="director-description">
                {selectedDirector.description}
              </p>
            )}
          </div>
        </aside>
      )}
    </section>
  );
};

export default Leadership;
